<template>
  <div class="layout-content">
    <!-- 顶部导航栏 -->
    <Header></Header>
    <!-- body 内容 -->
    <div class="body-content" :class="isMobile ? 'body-content-active' : ''">
      <!-- <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          :key="$route.fullPath"
        ></router-view>
      </keep-alive> -->
      <router-view v-if="$route.path == '/article'"></router-view>
      <router-view
        v-if="$route.path != '/article'"
        :key="$route.fullPath"
      ></router-view>
    </div>

    <!-- 底部导航栏 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/common/header.vue'
import Footer from '@/components/common/footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  }
}
</script>

<style scoped lang="scss">
.layout-content {
  display: flex;
  flex-direction: column;

  .body-content {
    margin-top: 197px;
    display: flex;
    flex-direction: column;
  }
  .body-content-active {
    margin-top: 60px;
  }
}
</style>
